export const UPDATE_EMAIL_ADDRESS = 'UPDATE_EMAIL_ADDRESS';

export const updateEmailInfo = email => {
  return {
    type: UPDATE_EMAIL_ADDRESS,
    payload: email,
  };
};
